module.exports = __webpack_public_path__ + "static/media/condes.f099f5f9.jpg";